<template>
  <div class="pt250 container-fluid">
    <faq-header :breadcrumb="isSearch ? {} : null" @onTopPage="isSearch = false"></faq-header>

    <div class="row">
      <div class="col-sm-12 col-lg-8 ">
        <div class="title-block first-child">
          <div class="section">キーワードから探す</div>
        </div>

        <div class="search-wrapper">
          <div class="txtKeywordWrapper">
            <tags-input element-id="tags"
                        placeholder=""
                        v-model="keywords"
                        :typeahead="true"
                        add-tags-on-blur
            ></tags-input>
          </div>

          <div class="btn-wrapper">
            <input @click="onSearch()" type="button" class="btn-search" value="">
          </div>
        </div>

        <div v-if="!isSearch" class="section my-2">
          <div class="title-block">
            <div class="section">カテゴリから探す</div>
          </div>
          <div class="category">
            <div class="row row-cols-2 row-cols-md-3">
              <template v-for="(category,idx) in init.categoryList">
                <div class="col mb-4 d-none d-md-block" :key="`category_${category.LEVEL_NO}_empty`"  v-if="idx === 4 && init.categoryList.length === 8" >
                </div>
                <div class="col mb-4" :key="`category_${category.LEVEL_NO}`" >
                  <a @click="onCategoryClick(category.LEVEL_NO)" class="card category" >
                    <div class="card-body d-flex flex-column justify-content-center">
                      <h5>{{ category.LEVEL_NM }}</h5>
                    </div>
                  </a>
                </div>
              </template>
            </div>
          </div>
        </div>

        <div v-if="isSearch" class="section my-4">
<!--          <div class="sub-title">検索結果</div>-->
          <div v-if="total > 0" class="my-2 text-center text-muted">{{total}}件中の{{(pageNo - 1) * pageSize + 1}} - {{ pageNo * pageSize > total ? total : pageNo * pageSize }}番目を表示</div>
          <div v-else class="my-2 text-center text-muted">検索条件に一致するデータがありませんでした。</div>

          <ul class="list-group ">
            <a @click="onFaqClick(faq.FAQ_NO)" :key="`faq_${faq.FAQ_NO}`" v-for="(faq,idx) in faqList" class="faq d-flex list-group-item text-break">
              <span class="badge light">{{ (pageNo - 1) * pageSize + idx+1}}</span>
              {{ faq.QUESTION }}
            </a>
          </ul>

          <div class="mt-4 row justify-content-center">
            <div class="col-3">
              <a @click="prevPage()" v-if="pageNo > 1" class="btn btn-primary" href="javascript:;" role="button">前のページ</a>
            </div>
            <div v-if="pageNo < totalPage" class="col-3">
              <a @click="nextPage()" class="btn btn-primary" href="javascript:;" role="button">次のページ</a>
            </div>
          </div>

        </div>
      </div>

      <div v-if="init.faqList && init.faqList.length > 0" class="col-sm-12 col-lg-4">
        <div class="section">
          <div class="title-block">
            <div class="section">よく見られている質問</div>
          </div>
          <ul class="list-group list-group-flush">
            <a @click="onFaqClick(faq.FAQ_NO)"  :key="`faq_${faq.FAQ_NO}`" v-for="(faq,idx) in init.faqList" class="faq d-flex list-group-item text-break">
              <span class="badge light">{{idx+1}}</span>
              {{ faq.QUESTION }}
            </a>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*
* Import libs and componnents
*/
import Loading from 'vue-loading-overlay';
import axios from "assets/js/request";
import common from "assets/js/common";
import SiteConstants from 'assets/const/SiteConstants.json';
import VoerroTagsInput from '@voerro/vue-tagsinput';
import "@voerro/vue-tagsinput/dist/style.css"

export default {
  /*
  * Name of component
  */
  name: "PT250FAQTopParts",
  props:{
    ptInitData: {
      type: Object,
      default: null,
    }
  },
  /*
  * Get data from parent component
  */
  components:
      {
        Loading,
        TagsInput:VoerroTagsInput,
        FaqHeader: () => import('./components/FaqHeader.vue')
      },
  data() {
    return {
      init: {
        categoryList: [],
        faqRankList: []
      },
      isSearch: false,
      keywords: [],
      pageNo: 1,
      pageSize: 20,
      faqList: [],
      total: 0,
      totalPage: 0
    }
  },
  mounted() {
    if (this.ptInitData){
      this.init = this.ptInitData;
      if(this.keywords.length > 0){
        this.doSearch();
      }
    }
  },
  methods: {
    onCategoryClick(categoryNo){
      this.$router.push({ name: SiteConstants.PG010, query: { pageNo: 51, categoryNo : categoryNo }});
    },
    doSearch(){
      this.faqList = [];
      this.$emit("event-loading", true);
      axios.post(this.$UrlConstants.ECSITE + this.$UrlConstants.PT250 + this.$UrlConstants.DO_SEARCH ,{ pageNo: this.pageNo,keywords: this.keywords }).then((response) => {

        this.isSearch = true;
        this.faqList = response.data.faqList;
        this.total = response.data.total;
        this.totalPage = response.data.totalPage;
        this.$router.push({ name: SiteConstants.PG010, query: { pageNo: 50, keywords: encodeURIComponent(JSON.stringify(this.keywords)) }});
      }).catch((error) => {
        common.errorAPI(error);
      }).finally(() => {
        this.$emit("event-loading", false);
      });
    },
    onSearch(){
      this.pageNo = 1;
      this.doSearch();
    },
    nextPage(){
      this.pageNo = this.pageNo + 1;
      this.doSearch();
    },
    prevPage(){
      this.pageNo = this.pageNo - 1;
      this.doSearch();
    },
    onFaqClick(faqNo){
      this.$router.push({ name: SiteConstants.PG010, query: { pageNo: 52, faqNo : faqNo }});
    },
    
  },
  created(){
    this.queryData = this.$route.query;
    this.paramsData = this.$route.params;
    if (this.queryData != null && this.queryData.keywords != null) {
      try {
        // クエリパラメータからデコードして復元 (JSON文字列からオブジェクトに変換)
        this.keywords = JSON.parse(decodeURIComponent(this.queryData.keywords));
      } catch (error) {
        console.error('Error parsing keywords:', error);
      }
    }
  },
}
</script>